import { withI18n } from 'react-i18next';
import PickUpDeliverAddressChange from './PickUpDeliverAddressChange';

export const pureComponent = PickUpDeliverAddressChange;
export default withI18n()(PickUpDeliverAddressChange);
